import {Component} from 'react';
import {store} from '../AppRenderer';

class Rbac extends Component {

  static hasPermission(permission) {
    const permissions = store.getState().menu.permissions;
    if (permission) {
      const splitedPermission = permission.split(' ');
      let p;
      for (p of splitedPermission) {
        if (permissions && (permissions.includes(p) || permissions.includes('*'))) {
          return true;
        }
      }
      return false;
    }
    return true;
  }

  render() {
    const {permission,children} = this.props;
    return Rbac.hasPermission(permission) ? children : null;
  }
}



export default Rbac;
